import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {reserveHistoryRoute} from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { TextInput } from '../../components/common/components'
import { setHistoryValue, searchHistory } from '../../actions'
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


export default function Search() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveHistoryRoute, (o) => o.path === location.pathname)

    const [captchaing, setCaptchaing] = useState(false)

    const [captcha, setCaptcha] = useState(null)

    const [capImg, setCapImg] = useState(null)

    const [captchaInput, setCaptchaInput] = useState("")

    const loadCaptcha = useCallback(
        () => {
            setCaptchaing(true)
            const fetchGetConfig = {
                method: 'GET',
                credentials: 'include'
            }
            //   var myImage = document.querySelector('#captcha202010190819')
            var imageUrl = `https://staff.kfsyscc.org/ca/captcha.jpg`

            fetch(imageUrl, fetchGetConfig).then((res) => {
                return res.blob()
            }).then((res) => {
                var objcetURL = URL.createObjectURL(res)
                setCapImg(objcetURL);

                fetch(`https://staff.kfsyscc.org/ca/digits`, fetchGetConfig).then((res) => {

                    return res.json()
                }).then((data) => {
                    // console.log(data)
                    //   if (!IS_PROD) {
                    //     setCaptcha('9999')
                    //   }
                    //   else {
                    setCaptcha(data.digit)
                    //   }
                    setCaptchaing(false)
                })
            })
        },
        [],
    );

    useEffect(() => {
        loadCaptcha()
    }, [])



    const search = (useSelector(state => state.getIn(["reserveHistory", "search"]))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    let query = useQuery();  

    let tk = query.get("tk") 


    const handlechange = useCallback((field, value) => {        

        dispatch(setHistoryValue({
            page:'search',
            field,
            value
        }))
    }, [dispatch])

    const handleNextClick = () => {       
        dispatch(searchHistory())
    }

    useEffect(() => {
        dispatch(setHistoryValue({
            page:'search',
            field:"PAT_IDNO",
            value:""
        }))
        dispatch(setHistoryValue({
            page:'search',
            field:"TICKET_NO",
            value:""
        }))
        dispatch(setHistoryValue({
            page:'search',
            field:"BIRTHDAY",
            value:""
        }))

        if(tk){
            dispatch(setHistoryValue({
                page:'search',
                field:"TICKET_NO",
                value:tk
            }))
        }
    }, [])

    return <Box className={layoutClasses.page}>        
        <Helmet>
            <title>{reserveHistoryRoute[idx].name}</title>
        </Helmet>
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveHistoryRoute[idx].name}
            </Typography>  
            <TextInput
                label="身分證字號"
                field="PAT_IDNO"
                value={search.PAT_IDNO}
                setValue={handlechange}
            />
            {/* <TextInput
                label="預約代碼"
                field="TICKET_NO"
                value={search.TICKET_NO}
                setValue={handlechange}
            /> */}
            <TextInput
                label="生日(YYYYMMDD)"
                field="BIRTHDAY"
                value={search.BIRTHDAY}
                setValue={handlechange}
            />
            <Grid container>
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6}>
                    <TextInput
                        label="驗證碼"
                        field="captchaInput"
                        value={captchaInput}
                        setValue={(field, value) => { setCaptchaInput(value) }}
                    />
                </Grid>
                 <Grid item xl={2} lg={4} md={4} sm={6} xs={6} style={{ padding: "5px" }}>
                    {capImg ? <img alt="captcha" src={capImg} style={{ height: "80%", objectFit: "contain" }} /> : null}
                </Grid>
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                    <Button color="primary" variant="contained" onClick={() => loadCaptcha()}>取得新驗證碼</Button>
                </Grid>
            </Grid>
        </Paper>
        {!search.loading?<Button
            variant="contained"
            color="primary"
            style={{ margin: "30px auto" }}
            onClick={() => { 
                if (captcha === "" || captcha !== captchaInput) {
                    Swal.fire("驗證碼不符", "", "error")
                    return
                }
                handleNextClick()
             }}
        >
            查詢
        </Button>:null}
    </Box>
}